@if (user) {
  <div id="tabContent" class="tabContent">
    @if (hasWorkspaces) {
      <pp-grid [ppOptions]="{ bodyPadding: true }">
        <ng-container title> {{ 'top_right_logo' | ppTranslate }} </ng-container>
        <ng-container titleBar-right>
          <div class="siteSettings__button-container">
            @if (newLogo) {
              <pp-button
                ppId="updateLogoBtn--cancel"
                ppStyle="secondary"
                ppSize="small"
                (ppAction)="cancelNewLogo()"
                >
                {{ 'cancel' | ppTranslate }}
              </pp-button>
            }
            @if (!newLogo) {
              <pp-button [ppStyle]="newLogo ? 'secondary' : 'primary'" ppSize="small">
                <label class="settingsNewSite__upload-button" for="LogoUpload">
                  {{ (logoId ? 'update' : 'add') | ppTranslate }}
                  {{ 'top_right_logo' | ppTranslate }}
                </label>
                <pp-upload id="LogoUpload--update" [ppId]="'LogoUpload'" (ppUpload)="setLogo($event)">
                </pp-upload>
              </pp-button>
            }
            @if (newLogo) {
              <pp-button
                ppId="updateLogoBtn--update"
                [ppStyle]="newLogo ? 'primary' : 'secondary'"
                [ppDisabled]="!newLogo"
                [ppProcess]="processingLogoUpdate"
                ppSize="small"
                (ppAction)="updateLogo()"
                >
                {{ 'confirm' | ppTranslate }}
              </pp-button>
            }
          </div>
        </ng-container>
        <ng-container body>
          @if (!logoId && !uploadedImage) {
            <div class="settingsSection__no-content">
              {{ 'no_pdf_logo_found' | ppTranslate }}
            </div>
          }
          @if (logoId && !uploadedImage) {
            <img
              ppImage
              class="siteSettingsPlan__site-plan"
              [ppSecureSrc]="'api/v1/images/' + logoId + '/file/size/bounded/1200'"
              />
          }
          @if (uploadedImage) {
            <img
              ppImage
              class="siteSettingsPlan__site-logo-new"
              [src]="uploadedImage"
              />
          }
        </ng-container>
      </pp-grid>
    }
  </div>
}
